import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

console.log('API_BASE_URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Variable para evitar múltiples llamadas
let isRedirecting = false;

// Callback para cuando el token expira
let onTokenExpiredCallback = null;

export const setOnTokenExpired = (callback) => {
  onTokenExpiredCallback = callback;
};

// Interceptor para manejar errores 401 (token expirado)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isRedirecting) {
      isRedirecting = true;

      // Limpiar token
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      delete api.defaults.headers.common['Authorization'];

      // Llamar al callback
      if (onTokenExpiredCallback) {
        onTokenExpiredCallback();
      }

      setTimeout(() => {
        isRedirecting = false;
      }, 1000);
    }
    return Promise.reject(error);
  }
);

export default api;
